import { render } from "./SalesFigures.vue?vue&type=template&id=3884c446"
import script from "./SalesFigures.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesFigures.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Dashboard/Table/SalesFigures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3884c446"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3884c446', __exports__)) {
    api.reload('3884c446', __exports__)
  }
  
  module.hot.accept("./SalesFigures.vue?vue&type=template&id=3884c446", () => {
    api.rerender('3884c446', render)
  })

}


export default __exports__